import { render, staticRenderFns } from "./GenerationHistoryListItemDesignBoard.vue?vue&type=template&id=9cd04d30"
import script from "./GenerationHistoryListItemDesignBoard.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryListItemDesignBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports